import { IGetAllPesquisaSatisfacaoUseCase } from "../../../presentation/useCases/read/get_all_pesquisa_satisfacao_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { PesquisaSatisfacaoLista } from "../../models/pesquisa_satisfacao_lista";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * GetAllPesquisaSatisfacaoUseCase
 */

export class GetAllPesquisaSatisfacaoUseCase
  extends BasePaginatedUseCase<PesquisaSatisfacaoLista>
  implements IGetAllPesquisaSatisfacaoUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) {
    super();
  }

  async getAllPesquisaSatisfacao(
    field: number | null,
    value: string | null,
    status: number | null,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const result = await this.repository.getAllPesquisaSatisfacao(
      field,
      value,
      status,
      page,
      rowsPerPage,
    );

    this._items = result.items;
    this._totalItems = result.totalItems;
    this._currentPage = result.currentPage;
    this._pageSize = result.pageSize;
  }
}
